import { PaperCardTemplate } from 'components/templates/PaperCardTemplate';
import React from 'react';

import { Box, Button, Divider, Stack, Typography } from '@mui/material';

import { TutorPlanCardBenefits } from '../TutorPlanCardBenefits';
import { TutorPlanCardHeader } from '../TutorPlanCardHeader';
import { ITutorUserPlanSubscription } from 'types/TutorUser';
import { TutorMyPlanUserInfo } from 'components/molecules/TutorPlan/TutorMyPlanUserInfo';
import { maskDate } from 'util/masks';
import { useTutorUserPlan } from 'context';

interface Props {
  planSubscription: ITutorUserPlanSubscription;
}

export const TutorPlanSubscriptionCard: React.FC<Props> = ({
  planSubscription,
}) => {
  const { showCancelPlanDialog, couponValues } = useTutorUserPlan();

  if (!planSubscription?.plan) {
    return null;
  }

  const { plan, expireAt, treatmentsLeft } = planSubscription;

  return (
    <PaperCardTemplate childrenProps={{ px: 0, pb: 0 }}>
      <Stack spacing={3} mb={6} px={6}>
        <Stack direction="row" justifyContent="space-between" spacing={2}>
          <Typography fontWeight={400} fontSize={24} color="#000000">
            MEU PLANO
          </Typography>

          <TutorPlanCardHeader
            planName={planSubscription.plan.title}
            planPrice={planSubscription.plan.price}
            discountPlanPrice={couponValues?.newValue}
            installmentText={plan.installmentText}
          />

          <TutorMyPlanUserInfo />
        </Stack>

        <Divider sx={{ pt: 1 }} />

        <TutorPlanCardBenefits
          pt={1}
          description={plan.description}
          benefits={plan.benefits}
        />
      </Stack>

      <Stack direction="row" mb={-1} bgcolor="#E4E7ED">
        <Box py={1.6} flex={1}>
          <Typography
            color="#4b4b4b99"
            fontSize={14}
            fontWeight={700}
            textAlign="center"
          >
            VÁLIDO ATÉ {maskDate(expireAt)}
          </Typography>
        </Box>

        <Box display="flex" alignItems="center">
          <Divider
            orientation="vertical"
            sx={{ bgcolor: '#4b4b4b99', height: '1.7em' }}
          />
        </Box>

        <Box py={1.6} flex={1}>
          <Typography
            color="#4b4b4b99"
            fontSize={14}
            fontWeight={700}
            textAlign="center"
          >
            RESTAM {treatmentsLeft} ATENDIMENTOS
          </Typography>
        </Box>

        <Button
          variant="contained"
          sx={{ color: '#FFFFFF', flex: 1, boxShadow: 'none', borderRadius: 0 }}
          onClick={showCancelPlanDialog}
          disabled={!planSubscription.active}
        >
          {planSubscription.active ? 'CANCELAR PLANO' : 'PLANO CANCELADO'}
        </Button>
      </Stack>
    </PaperCardTemplate>
  );
};
